import { render } from "./RelativeNavbar.vue?vue&type=template&id=3c192fbe&scoped=true&ts=true"
import script from "./RelativeNavbar.vue?vue&type=script&lang=ts"
export * from "./RelativeNavbar.vue?vue&type=script&lang=ts"

import "./RelativeNavbar.vue?vue&type=style&index=0&id=3c192fbe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c192fbe"]])

export default __exports__